import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';
import Colors from '../colors';

function LoadingSpinner({ isLoading }) {
  return (
    <Backdrop
      sx={{ color: Colors.white, zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isLoading} >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

export default LoadingSpinner;